const messages = {
  fleetWithOptions:
    "Ne možete odabrati flotu ako ste odabrali opcije",
  addProduct: "Vaš proizvod je dodan u košaricu.",
  addProducts: "Vaši proizvodi su dodani u košaricu.",
  profileSaved: "Podaci vašeg profila su spremljeni",
  canAddProduct: "Nemate dovoljno bodova.",
  customerNumberSaved: "Broj kupca spremljen",
  customerNumberExist: "Broj kupca dostupan",
  complaintForm: "Vaš zahtjev je prihvaćen. Molimo sačekajte odgovor",
  openHourSaved: "Radno vrijeme je spremljeno",
  changeParentId:
    "Ne možete mijenjati podružnicu s većim brojem kupca ako ima podređene podružnice.",
  requestSent: "Zahtjev je poslan",
  completeProfileRequired:
    "Morate ispuniti vaš profil 100% da biste mogli nastaviti s kupovinama u shopu.",
  accessDenied: "Pristup odbijen",
  incomplete_address: "Adresa je nepotpuna. Molimo provjerite",
  waitMoment: "Sačekajte trenutak",
  downloadFinished: "Preuzimanje završeno",
  selectOneField: "Odaberite jedno polje",
  noVoucher: "Vaučer nije pronađen",
  cannotAddCsNumber: "Ne možete dodati broj kupca",
  messagesDeletedSuccess: "Poruke su obrisane.",
  messagesDeletedError: "Brisanje poruka nije uspjelo.",
  fillProfile: "Ispunite profil da biste mogli preuzeti certifikat,",
  favoriteAdded: "Dodano u omiljene.",
  favoriteRemoved: "Uklonjeno iz omiljenih.",
};

export default {
  messages,
};
